import { SideNavDashboards } from "@/SideNavDashboards/SideNavDashboards";
import { PrivateRoute } from "@/auth";
import { SidebarLayout } from "@/components/templates/SidebarLayout/SidebarLayout";
import MarketplacePage from "@/pages/marketplace";
import MarketplaceDashboardDetailPage from "@/pages/marketplace-dashboard";
import ProfilePage from "@/pages/profile";
import * as route from "@/route";
import ActivateWorkspace from "@/route/activate/workspace";
import React from "react";
import { Redirect, Switch } from "react-router-dom";

export function NcmArea() {
  return (
    <Switch>
      <PrivateRoute exact={true} path={route.pageNcm.pattern() + route.pageProfiles.pattern()}>
        <ProfilePage showCustomLogo={true} />
      </PrivateRoute>
      <PrivateRoute exact={true} path={route.pageNcm.pattern() + route.pageMarketplace.pattern()}>
        <MarketplacePage showCustomLogo={true} />
      </PrivateRoute>
      <PrivateRoute exact={true} path={route.pageNcm.pattern() + route.pageMarketplaceDashboard.pattern()}>
        <MarketplaceDashboardDetailPage showCustomLogo={true} />
      </PrivateRoute>
      <PrivateRoute exact={true} path={route.pageNcmWorkspace.pattern()}>
        <SidebarLayout sidebar={<SideNavDashboards showCustomLogo={true} />}>
          <ActivateWorkspace />
        </SidebarLayout>
      </PrivateRoute>
      <Redirect exact from={""} to={route.pageNcm.pattern() + route.pageProfiles.pattern()} />
    </Switch>
  );
}
